var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-container"},[_c('div',{staticClass:"label-block"},[_c('div',{staticClass:"text--secondary"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"value-block"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }